import { Link, LinkProps, Tile } from 'ia-react-core';
import styled from 'styled-components';

import { FC } from 'react';
import { ReactComponent as WarningIcon } from '../../../assets/warning-actionReq.svg';

export const StyledWarningIcon = styled(WarningIcon)`
  color: ${({ theme }) => theme?.colors.orange2};
`;
export const StyledTile = styled(Tile)`

div
   {
     &:last-of-type {
       a{&:last-of-type{
    margin-bottom: 0;}
  }}
}
`;

export const StyledLink = styled<FC<LinkProps>>(Link)`
  font-weight: 600;
  white-space: initial;
  text-align: left;
  border-bottom-width: 10px;
  margin-bottom: 13px;
  bottom: 12px;
  top: 1px;
  width: 90%;
  &:hover {
    text-decoration: underline;
  }
  
  &:active {
    color: ${({ theme }) => theme.colors.blue10};
    text-decoration: underline;
  }
  
  overflow: hidden;
  display: -webkit-box;
  line-clamp: 4;
  -webkit-line-clamp: 4;
  text-overflow: ellipsis;
  box-orient: vertical;
  -webkit-box-orient: vertical;
`;
